<template>
  <div class="bg-primary">
    <!-- Header -->
    <div class="header bg-gradient-blue py-7 py-lg-6 pt-lg-5">
      <b-container>
        <div class="header-body text-center mb-5">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">
                Reset your password
              </h1>
              <p class="text-lead text-white">
                Forgotten your password? Please use the form below to reset it.
              </p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-primary" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--7 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <base-alert
                v-if="errorMessage"
                :dismissible="false"
                type="default"
                >Error: {{ errorMessage }}</base-alert
              >
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <base-alert v-if="success" :dismissible="false" type="success">
                  We've sent you an email. Please check your inbox (make sure
                  you check the spam folder) and follow the instructions to
                  reset your password.
                </base-alert>
                <b-form
                  v-if="!success"
                  role="form"
                  @submit.prevent="handleSubmit(createPasswordTicket)"
                >
                  <base-input
                    alternative
                    class="mb-3"
                    name="Email"
                    :rules="{ required: true, email: true }"
                    :debounce="500"
                    prepend-icon="ni ni-email-83"
                    placeholder="Email address"
                    v-model="model.email"
                  ></base-input>

                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4 btn-block"
                    >
                      <span v-if="!working">
                        Request password reset
                        <i class="fa fa-arrow-right ml-2"></i>
                      </span>
                      <span v-else>
                        Please wait&hellip;
                        <i class="fa fa-spin fa-spinner ml-2"></i>
                      </span>
                    </base-button>
                  </div>

                  <base-alert
                    v-if="errorMessage"
                    :dismissible="false"
                    type="default"
                    icon="fas fa-exclamation-circle"
                    >Error: {{ errorMessage }}</base-alert
                  >
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/login" class="text-light">
                <small>Log in</small>
              </router-link>
            </b-col>
            <b-col cols="6" class="text-right">
              <router-link to="/register" class="text-light">
                <small>Create new account</small>
              </router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { BaseAlert } from "@/components";
import { get } from "dot-prop";

export default {
  name: "forgotten-password",
  components: {
    BaseAlert
  },
  data() {
    return {
      model: {
        email: ""
      },
      working: false,
      success: false,
      errorMessage: null
    };
  },
  methods: {
    createPasswordTicket: function() {
      // this will be called only after form is valid. You can do api call here to login
      this.working = true;
      this.errorMessage = null; // reset it

      const requestBody = {
        emailAddress: this.model.email
      };

      this.axios
        .post("/v1/password-reset-tickets", requestBody)
        .then(response => {
          this.working = false;
          this.success = true;
        })
        .catch(error => {
          this.working = false;
          this.errorMessage = `Error requesting password reset: ${error.response.statusText}`;
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    }
  }
};
</script>
